(function () {
  'use strict';
  if (window.healthyQuoteLoaded) return;
  window.healthyQuoteLoaded = true;
  const storageKey = 'healthy-italia:event-quote:v2';
  function init(scope) {
    scope.querySelectorAll('[data-event-quote]').forEach(root => {
      if (root.dataset.quoteInitialized) return;
      root.dataset.quoteInitialized = 'true';
      const config = JSON.parse(root.querySelector('[data-quote-config]').textContent);
      const settings = config.settings, items = config.items;
      const guestInput = root.querySelector('[data-guests]');
      const download = root.querySelector('[data-download-quote]');
      const error = root.querySelector('[data-quote-error]'), request = root.querySelector('[data-request]');
      const packages = [...root.querySelectorAll('[data-package]')], addons = [...root.querySelectorAll('[data-addon]')];
      let current = null, saveTimer, saveQueue = Promise.resolve(), lastSaved = '';
      const saveStatus = document.createElement('p');
      saveStatus.setAttribute('role','status'); saveStatus.className = 'eq-notice';
      request.after(saveStatus);
      function persist() {
        if (!current || (window.Shopify && Shopify.designMode)) return Promise.resolve();
        const snapshot = JSON.parse(JSON.stringify(current));
        const signature = JSON.stringify({...snapshot, savedAt:0});
        saveQueue = saveQueue.catch(() => {}).then(async () => {
          if (signature === lastSaved) return;
          saveStatus.textContent = 'Saving your quote…';
          try {
            await window.HealthyEventRequest.quote(root, snapshot);
            lastSaved = signature;
            saveStatus.textContent = 'Quote saved.';
          } catch (error) {
            saveStatus.textContent = 'Your quote could not be saved. Select Book your event to retry.';
            throw error;
          }
        });
        return saveQueue;
      }
      let format;
      try { format = new Intl.NumberFormat('en-US', { style: 'currency', currency: settings.currency || 'USD' }); }
      catch (_) { error.hidden = false; request.setAttribute('aria-disabled', 'true'); return; }
      const money = cents => format.format(cents / 100);
      const find = id => items.find(item => item.id === id);
      if (packages[0]) packages[0].checked = true;
      try {
        const saved = JSON.parse(sessionStorage.getItem(storageKey));
        if (saved && Date.now() - saved.savedAt < 7200000) {
          if (Number.isInteger(saved.headcount)) guestInput.value = saved.headcount;
          const selected = packages.find(input => input.value === saved.packageId);
          if (selected) selected.checked = true;
          addons.forEach(input => { input.checked = Array.isArray(saved.addonIds) && saved.addonIds.includes(input.value); });
        }
      } catch (_) { /* A missing draft starts with the default configuration. */ }
      root.querySelectorAll('[data-base-price],[data-extra-price],[data-addon-price]').forEach(el => {
        const id = el.dataset.basePrice || el.dataset.extraPrice || el.dataset.addonPrice;
        const item = find(id);
        el.textContent = money(Math.round(Number(el.hasAttribute('data-extra-price') ? item.settings.extra : item.settings.price) * 100));
      });
      function update() {
        try {
          const selected = packages.find(input => input.checked);
          if (!selected || !guestInput.checkValidity()) throw new Error('Incomplete selection');
          const pkg = find(selected.value), headcount = Number(guestInput.value);
          // Normalize exclusive choices even when restoring a stale draft.
          const groups = new Set();
          const selectedExtras = addons.filter(input => {
            if (!input.checked) return false;
            const group = find(input.value).settings.group;
            if (group && group !== 'none') {
              if (groups.has(group)) { input.checked = false; return false; }
              groups.add(group);
            }
            return true;
          }).map(input => find(input.value));
          const totals = HealthyEventQuoteMath.calculate(pkg.settings, headcount, selectedExtras, settings);
          root.querySelectorAll('[data-total]').forEach(el => { el.textContent = money(totals[el.dataset.total]); });
          root.querySelector('[data-selected-name]').textContent = pkg.settings.title + ' · ' + headcount;
          let lineList = root.querySelector('[data-extra-lines]');
          if (!lineList) { lineList = document.createElement('ul'); lineList.dataset.extraLines = ''; root.querySelector('.eq-summary dl').before(lineList); }
          lineList.replaceChildren();
          totals.lines.forEach(line => { const li = document.createElement('li'); li.textContent = line.title + ' — ' + money(line.amount); lineList.append(li); });
          current = { version: 1, currency: settings.currency || 'USD', packageTitle: pkg.settings.title,
            packageDetail: pkg.settings.included + ' ' + settings.included_label + ' · ' + money(Math.round(Number(pkg.settings.extra) * 100)) + ' ' + settings.extra_label,
            serviceRate: Number(settings.service_rate), taxRate: Number(settings.tax_rate),
            extraDetails: selectedExtras.map(item => ({ title: item.settings.title, quantity: item.settings.basis === 'per_guest' ? headcount : 1, unitAmount: Math.round(Number(item.settings.price) * 100), amount: totals.lines.find(line => line.id === item.id).amount })),
            savedAt: Date.now(), headcount, packageId: pkg.id, packageName: pkg.settings.booking_name, addonIds: selectedExtras.map(x => x.id), totals,
            notes: [pkg.settings.title + ' · ' + headcount + ' guests', ...totals.lines.map(x => x.title + ': ' + money(x.amount)), settings.total_label + ': ' + money(totals.total), settings.each_label + ': ' + money(totals.each)].join('\n') };
          try { if (!(window.Shopify && Shopify.designMode)) sessionStorage.setItem(storageKey, JSON.stringify(current)); } catch (_) { /* The request button reports unavailable storage. */ }
          error.hidden = true; request.removeAttribute('aria-disabled');
          if (download) download.disabled = false;
          clearTimeout(saveTimer);
          saveTimer = setTimeout(() => persist().catch(() => {}), 700);
        } catch (_) {
          current = null; if (download) download.disabled = true; error.hidden = false; request.setAttribute('aria-disabled', 'true');
          root.querySelectorAll('[data-total]').forEach(el => { el.textContent = '—'; });
        }
      }
      guestInput.addEventListener('input', update);
      packages.forEach(input => input.addEventListener('change', update));
      addons.forEach(input => input.addEventListener('change', () => {
        const group = find(input.value).settings.group;
        if (input.checked && group && group !== 'none') addons.forEach(other => { if (other !== input && find(other.value).settings.group === group) other.checked = false; });
        update();
      }));
      if (download) download.addEventListener('click', () => {
        update();
        if (!current || (window.Shopify && Shopify.designMode)) return;
        const pdfError = root.querySelector('[data-download-error]');
        pdfError.hidden = true;
        try {
          const lead = JSON.parse(sessionStorage.getItem('healthy-italia:event-lead:v1'));
          if (!lead || !lead.captured || Date.now() - lead.savedAt >= 7200000) { location.assign(root.dataset.landingUrl); return; }
          window.HealthyQuotePDF(current, lead, settings).save('healthy-italia-quote-' + new Date().toISOString().slice(0,10) + '.pdf');
        } catch (_) { pdfError.hidden = false; }
      });
      request.addEventListener('click', async event => {
        event.preventDefault();
        update();
        if (!current || (window.Shopify && Shopify.designMode)) { event.preventDefault(); return; }
        try {
          const lead = JSON.parse(sessionStorage.getItem('healthy-italia:event-lead:v1'));
          if (!lead || !lead.captured || Date.now() - lead.savedAt >= 7200000) {
            event.preventDefault(); location.assign(root.dataset.landingUrl); return;
          }
          sessionStorage.setItem(storageKey, JSON.stringify(current));
          clearTimeout(saveTimer);
          await persist();
          location.assign(request.href);
          root.dispatchEvent(new CustomEvent('healthyitalia:quote-ready', { bubbles: true, detail: current }));
        } catch (_) {
          event.preventDefault();
          saveStatus.textContent = 'Your quote could not be saved. Select Book your event to retry.';
        }
      });
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
